// Stand view: front HMI (1920x720) bezel stacked over rear HMI (1280x800) bezel,
// scaled as a single unit to fit the viewport. The stack renders at native size
// (bezels + gap included); we only apply a uniform CSS scale so both screens stay
// pixel-accurate to the car.
const stage = document.getElementById('stage');

function fit(): void {
  if (!stage) return;
  // offsetWidth/Height are the untransformed layout size, so they already account
  // for the bezel borders, padding and the gap between frames.
  const scale = Math.min(window.innerWidth / stage.offsetWidth, window.innerHeight / stage.offsetHeight);
  stage.style.transform = `translate(-50%, -50%) scale(${scale})`;
}

window.addEventListener('resize', fit);
fit();

// --- Branch switcher -------------------------------------------------------
// Populated from branches.json (written by the CI workflow from the live S3
// listing). `../../branches.json` resolves to <bucket>/avride/av/hmi/branches.json
// on both hmi.avride.dev (/<slug>/stand/) and direct static.avride.dev links
// (/avride/av/hmi/<slug>/stand/). Selecting a branch swaps the slug segment.
const APP_DIRS = new Set(['stand', 'hmi', 'passenger']);

function currentSlug(): string | null {
  const parts = window.location.pathname.split('/').filter(Boolean);
  let i = parts.length - 1;
  if (parts[i] && !APP_DIRS.has(parts[i])) i--; // trailing index.html
  return APP_DIRS.has(parts[i]) ? (parts[i - 1] ?? null) : null;
}

async function initBranchPicker(): Promise<void> {
  const picker = document.getElementById('branch-picker');
  const select = document.getElementById('branch-select') as HTMLSelectElement | null;
  if (!picker || !select) return;

  let branches: string[] = [];
  try {
    const res = await fetch('../../branches.json', { cache: 'no-store' });
    if (res.ok) branches = await res.json();
  } catch {
    // No manifest (e.g. local dev) — leave the picker hidden.
  }

  const slug = currentSlug();
  if (slug && !branches.includes(slug)) branches.push(slug);
  if (branches.length === 0) return;

  branches.sort((a, b) => (a === 'main' ? -1 : b === 'main' ? 1 : a.localeCompare(b)));

  select.replaceChildren(
    ...branches.map(b => {
      const opt = document.createElement('option');
      opt.value = b;
      opt.textContent = b;
      opt.selected = b === slug;
      return opt;
    }),
  );

  select.addEventListener('change', () => {
    window.location.href = `../../${select.value}/stand/`;
  });

  picker.removeAttribute('hidden');
}

void initBranchPicker();
